import React, { useState, useEffect, useRef, useMemo } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
    FaPlus,
    FaSortAmountUp,
    FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaChevronDown,
    FaChevronUp,
    FaDesktop,
    FaGlobeAfrica,
    FaEllipsisV,
    FaOutdent,
    FaParking,
    FaHistory,
    FaSignOutAlt,
} from "react-icons/fa";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import GlossaireSidebar from "../../composant_reutilisable/glossaireSidebar";
import Pas_acces from "../../composant_reutilisable/pas_acces";
import MenuVisibilite from "../../composant_reutilisable/menu_visibilite";
import EntrerModal from "./EntrerModal";
import { FaRoadBarrier } from "react-icons/fa6";
import ModalHistorique from "./modal_historique";

const ListeParcTampon = () => {
    useAuth();
    const location = useLocation();
    const user_id = localStorage.getItem("userId");
    const { parcRef } = location.state || {};
    const [camions, setCamions] = useState([]);
    const [selectedCamion, setSelectedCamion] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [sortConfig, setSortConfig] = useState({
        key: "date_creation",
        direction: "descending",
    });
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [showInfo, setShowInfo] = useState(true);
    const [showEntrerModal, setShowEntrerModal] = useState(false);
    const [showParcTamponModal, setShowParcTamponModal] = useState(false);
    // const [selectedParcTampon, setSelectedParcTampon] = useState(null);
    const [showModalHistorique, setShowModalHistorique] = useState(false);
    const [showErreurModal, setShowErreurModal] = useState(false)
    const [showRemplacerCamionModal, setShowRemplacerCamionModal] = useState(false);
    const [isLoadingRemplacer, setIsLoadingRemplacer] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Parc tampon";
        }
    }, [user_id]);

    const [userData, setUserData] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);



    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        // Ajouter 1 heure pour corriger le décalage horaire
        date.setHours(date.getHours() + 1);
        const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
        const optionsTime = {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };
        const formattedDate = date.toLocaleDateString("fr-FR", optionsDate);
        const formattedTime = date.toLocaleTimeString("fr-FR", optionsTime);
        return `${formattedDate} ${formattedTime}`;
    };

    const [statutFilter, setStatutFilter] = useState("tous");

    const handleStatutFilterChange = (e) => {
        setStatutFilter(e.target.value);
        setCurrentPage(1); // Réinitialiser à la première page quand on change le filtre
    };

    const fetchCamionsParcTampon = async (page = currentPage, perPage = itemsPerPage) => {
        try {
            setIsLoading(true);
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/listes-parc-tampon/?page=${page}&per_page=${perPage}&parcRef=${parcRef || userData?.parc}`
            );

            if (!response.ok) {
                throw new Error("Erreur lors de la récupération des camions en parc tampon");
            }

            const data = await response.json();

            const camionsTries = (data.camions || []).sort(
                (a, b) => b.ordre - a.ordre
            );

            const camionsAvecRang = camionsTries.map((camion, index, array) => ({
                ...camion,
                rang: array.length - index,
            }));

            setCamions(camionsAvecRang);
            setCurrentPage(data.page || 1);
            setTotalPages(data.total_pages || 1);
            setTotalItems(data.total_items || 0);
        } catch (error) {
            console.error("Erreur lors du fetch des camions:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCamionsParcTampon();
    }, []);

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: "", type: "" });
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`
                );
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);

    const columnLabels = {
        date_creation: "Date d'entrée",
        date_sortie_reele: "Date de sortie",
        ordre: "Ordre",
        atellage: "Type d'attelage",
        camion: "Camion",
        reference_carte_transport_1: "Réf. carte transport 1",
        reference_carte_transport_2: "Réf. carte transport 2",
        tete: "Tracteur",
        queue: "Remorque",
        immatriculation: "Immatriculation",
        nationalite_vehicule: "Nationalité du véhicule",
        nationalite_carte_transport_tete: "Nationalités carte transport tracteur",
        nationalite_carte_transport_queue: "Nationalités carte transport remorque",
        nationalite_carte_transport_immatriculation: "Nationalités carte transport non articulé",
        proprietaire_tete: "Propriétaire tracteur",
        proprietaire_queue: "Propriétaire remorque",
        proprietaire_non_articule: "Propriétaire non articulé",
        numero_proprietaire_tete: "Tél. propriétaire tracteur",
        numero_proprietaire_queue: "Tél. propriétaire remorque",
        numero_proprietaire_non_articule: "Tél. propriétaire non articulé",
        charge_utile: "Charge utile totale",
        charge_utile1: "Charge utile 1",
        charge_utile2: "Charge utile 2",
        nombre_essieux1: "Essieux 1",
        nombre_essieux2: "Essieux 2",
        tuslock2: "Nombre de twist lock",
        conducteur_principal: "Conducteur principal",
        numero_permis_principal: "Permis principal",
        categorie_permis_principal: "Catégorie permis principal",
        tel_conducteur_principal: "Tél. conducteur principal",
        conducteur_assistant: "Conducteur assistant",
        numero_permis_assistant: "Permis assistant",
        categorie_permis_assistant: "Catégorie permis assistant",
        tel_conducteur_assistant: "Tél. conducteur assistant",
        type_camion: "Type de camion",
        statut: "Statut",
        ref_categorie: "Référence catégorie",
        destination: "Destination",
        parc: "Parc",
        type_parc: "Type de parc",
        utilisateur: "Ajouté par",
    };

    const [visibleColumns, setVisibleColumns] = useState({
        date_creation: false,
        date_sortie_reele: true,
        ordre: true,
        atellage: false,
        camion: true,
        reference_carte_transport_1: false,
        reference_carte_transport_2: false,
        tete: false,
        queue: false,
        immatriculation: false,
        nationalite_vehicule: false,
        nationalite_carte_transport_tete: false,
        nationalite_carte_transport_queue: false,
        nationalite_carte_transport_immatriculation: false,
        proprietaire_tete: false,
        proprietaire_queue: false,
        proprietaire_non_articule: false,
        numero_proprietaire_tete: false,
        numero_proprietaire_queue: false,
        numero_proprietaire_non_articule: false,
        charge_utile: false,
        charge_utile1: false,
        charge_utile2: false,
        nombre_essieux1: false,
        nombre_essieux2: false,
        tuslock2: false,
        conducteur_principal: true,
        numero_permis_principal: false,
        categorie_permis_principal: false,
        tel_conducteur_principal: true,
        conducteur_assistant: false,
        numero_permis_assistant: false,
        categorie_permis_assistant: false,
        tel_conducteur_assistant: false,
        type_camion: true,
        genre: false,
        statut: true,
        ref_categorie: false,
        destination: false,
        parc: true,
        type_parc: false,
        utilisateur: false,
        date_arrivee_parc_tampon: true,
        date_sortie_parc_tampon: false,
        utilisateur_arrivee: false,
        utilisateur_sortie: false
    });

    const getImmatriculation = () => {
        if (!selectedCamion) return "N/A";

        if (selectedCamion.atellage === "1") {
            return `${selectedCamion?.tete || ""} + ${selectedCamion?.queue || ""}`;
        }

        return selectedCamion?.immatriculation || "N/A";
    };

    const getButtonStyle = (statut) => {
        const config = STATUT_ACTIONS[statut];

        return {
            padding: "8px 16px",
            display: "flex",
            alignItems: "center",
            cursor: config?.disabled ? "not-allowed" : "pointer",
            opacity: config?.disabled ? 0.5 : 1,
        };
    };

    const STATUT_ACTIONS = {
        Sorti: {
            action: (n) => handleShowParcTamponModal(n),
            disabled: false,
        },
        en_retard: {
            action: (n) => handleShowErreurModal(n),
            disabled: false,
        },
        arrive_parc_tampon: {
            action: null,
            disabled: true,
        },
    };

    const handleShowErreurModal = (camion) => {
        setSelectedCamion(camion);
        setShowErreurModal(true);
    };

    const handleShowParcTamponModal = (camion) => {
        setSelectedCamion(camion);
        setShowParcTamponModal(true);
    };

    const handleShowRemplacerModal = (camion) => {
        setSelectedCamion(camion);
        setShowRemplacerCamionModal(true);
    };

    const handleCloseRemplacerModal = () => {
        setShowRemplacerCamionModal(false);
    };

    const handleParcTamponClick = (n) => {
        const config = STATUT_ACTIONS[n.statut];

        if (!config) {
            console.warn("Statut non géré :", n.statut);

            // 👉 fallback UX
            setShowErreurModal(true);
            return;
        }

        if (config.disabled) return;

        config.action?.(n);
        setOpenDropdownId(null);
    };

    const handleArriveeParcTampon = async () => {
        if (!selectedCamion) {
            // showAlert("Veuillez sélectionner un parc tampon", "danger");
            return;
        }

        const url = `${process.env.REACT_APP_HOTE}/enregistrer-arrivee-parc-tampon/${selectedCamion.id}/${user_id}/`;
        setIsLoading(true);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    // parc_tampon_id: selectedParcTampon.value,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showAlert("Arrivée au parc tampon enregistrée avec succès !");
                setShowParcTamponModal(false);
                setSelectedCamion(null);
                fetchCamionsParcTampon();
            } else {
                showAlert(data.message || "Erreur lors de l'enregistrement", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Erreur réseau", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    const handleRemplacerCamionSortir = async () => {
        setIsLoadingRemplacer(true);
        try {
            if (selectedCamion) {
                const token = localStorage.getItem('access_token');
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/api/remplacement-manuelle-sorti/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            tour_id: selectedCamion.id,
                            user_id: user_id
                        }),
                    }
                );

                const data = await response.json();

                if (response.ok && data.success) {
                    showAlert(data.message);
                    fetchCamionsParcTampon();

                } else {
                    showAlert(data.error || "Erreur lors de la sortie de rang", "danger");
                }
            }
        } catch (error) {
            console.error("Erreur lors de la sortie de rang:", error);
            showAlert("Une erreur s'est produite", "danger");
        } finally {
            setIsLoadingRemplacer(false);
            setShowRemplacerCamionModal(false);
        }
    };


    const filteredCamions = camions.filter((n) => {
        const searchTermLower = searchTerm.toLowerCase();

        // Filtre par recherche
        const matchesSearch = (
            (n.tete__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
            (n.queue__numero_immatriculation?.toLowerCase().includes(searchTermLower)) ||
            (n.immatriculation?.toLowerCase().includes(searchTermLower)) ||
            (n.proprietaire_tete?.toLowerCase().includes(searchTermLower)) ||
            (n.proprietaire_queue?.toLowerCase().includes(searchTermLower)) ||
            (n.proprietaire_non_articule?.toLowerCase().includes(searchTermLower)) ||
            (n.nom_conducteur?.toLowerCase().includes(searchTermLower)) ||
            (n.type_camion?.toLowerCase().includes(searchTermLower)) ||
            (n.statut?.toLowerCase().includes(searchTermLower)) ||
            (n.destination?.toLowerCase().includes(searchTermLower)) ||
            (n.parc?.toLowerCase().includes(searchTermLower)) ||
            (n.reference_carte_transport_1?.toLowerCase().includes(searchTermLower)) ||
            (n.reference_carte_transport_2?.toLowerCase().includes(searchTermLower)) ||
            (n.numero_permis_principal?.toLowerCase().includes(searchTermLower)) ||
            (n.lot_ref?.toLowerCase().includes(searchTermLower))
        );

        // Filtre par statut
        const matchesStatut = statutFilter === "tous" || n.statut === statutFilter;

        return matchesSearch && matchesStatut;
    });

    const sortedCamions = [...filteredCamions].sort((a, b) => {
        if (!sortConfig.key) return 0;

        const aCamion = `${a.tete__numero_immatriculation} + ${a.queue__numero_immatriculation}`;
        const bCamion = `${b.tete__numero_immatriculation} + ${b.queue__numero_immatriculation}`;

        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (sortConfig.key === "camion") {
            aValue = aCamion;
            bValue = bCamion;
        }

        aValue = aValue ? aValue.toString().toLowerCase() : "";
        bValue = bValue ? bValue.toString().toLowerCase() : "";

        if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
        fetchCamionsParcTampon(1, Number(e.target.value));
    };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem("groupe_id");

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem("groupe_id");
        const accesGroupeStored = localStorage.getItem("accesGroupe");

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`
                );
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces
                            .map((item) =>
                                item.acces
                                    ? item.acces
                                        .replace(/[\[\]']/g, "")
                                        .trim()
                                        .split(",")
                                        .map((access) => access.trim())
                                    : []
                            )
                            .flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem("groupe", data.groupe);
                    localStorage.setItem(
                        "accesGroupe",
                        JSON.stringify(cleanedAccessArray)
                    );
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Parc_tampon")) {
        return <Pas_acces />;
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaParking size={25} className="mr-2" />
                                    Parc tampon
                                    <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span>
                                </div>
                            </h2>
                            <div
                                className={`info-box p-0 col-lg-6 ${showInfo ? "open" : ""}`}
                            >
                                <small>
                                    <table className="table table-bordered ">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <span className="badge badge-success">
                                                        Camion en route
                                                    </span>
                                                </th>
                                                <th>
                                                    <span className="badge badge-primary">Camion entré</span>
                                                </th>
                                                <th>
                                                    <span className="badge bg-danger">Camion en retard</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    Le camion a quitté le parc de regroupement et est en route vers le parc tampon.
                                                </td>
                                                <td>
                                                    Le camion a été enregistrer et est présent sur le parc tampon.
                                                </td>
                                                <td>
                                                    Le camion a accusé du retard car il n'a pas respecté le délai pour se présenter
                                                    sur le parc tampon par conséquent il ne peut pas avoir accès au parc tampon.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </small>
                            </div>

                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>

                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Parc tampon
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div
                            className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}
                        >
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "10px",
                                    cursor: "pointer",
                                }}
                            >
                                <i className="fa fa-close"></i>
                            </span>
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="d-flex flex-wrap align-items-center mb-2 mb-md-0 gap-md-3">
                                                    <div className="me-4 mb-2 mb-md-0 mr-2">
                                                        <select
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                            className="form-select bg-default p-1"
                                                            style={{
                                                                width: "auto",
                                                                border: "1px black solid",
                                                                borderRadius: "5px",
                                                            }}
                                                        >
                                                            <option value={5}>5</option>
                                                            <option value={10}>10</option>
                                                            <option value={20}>20</option>
                                                            <option value={50}>50</option>
                                                        </select>
                                                    </div>

                                                    <div className="me-2 mb-2 mr-2 mb-md-0">
                                                        <select
                                                            value={statutFilter}
                                                            onChange={handleStatutFilterChange}
                                                            className="form-select bg-default p-1"
                                                            style={{
                                                                width: "auto",
                                                                border: "1px black solid",
                                                                borderRadius: "5px",
                                                                minWidth: "80px",
                                                            }}
                                                        >
                                                            <option value="tous">Tous les statuts</option>
                                                            <option value="Sorti">Camion en route</option>
                                                            <option value="arrive_parc_tampon">Camion entré</option>
                                                            <option value="en_retard">Camion en retard</option>
                                                        </select>
                                                    </div>

                                                    <div className="column-selector position-relative">
                                                        <MenuVisibilite
                                                            title="Visibilité"
                                                            columnLabels={columnLabels}
                                                            visibleColumns={visibleColumns}
                                                            setVisibleColumns={setVisibleColumns}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row justify-content-center align-items-center">
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control mr-2"
                                                        style={{ maxWidth: "150px", width: "100%" }}
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <div className="table-responsive">
                                                    <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                        <thead>
                                                            <tr>
                                                                {visibleColumns.date_sortie_reele && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("date_sortie_reele")}
                                                                    >
                                                                        Date de sortie
                                                                        {sortConfig.key === "date_sortie_reele" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.ordre && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("ordre")}
                                                                    >
                                                                        N° Ordre
                                                                        {sortConfig.key === "ordre" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.atellage && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("atellage")}
                                                                    >
                                                                        Attelage
                                                                        {sortConfig.key === "atellage" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.camion && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("camion")}
                                                                    >
                                                                        Camion
                                                                        {sortConfig.key === "camion" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.reference_carte_transport_1 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("reference_carte_transport_1")}
                                                                    >
                                                                        Réf. carte transport 1
                                                                        {sortConfig.key === "reference_carte_transport_1" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.reference_carte_transport_2 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("reference_carte_transport_2")}
                                                                    >
                                                                        Réf. carte transport 2
                                                                        {sortConfig.key === "reference_carte_transport_2" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.tete && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("tete")}
                                                                    >
                                                                        Tracteur
                                                                        {sortConfig.key === "tete" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.queue && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("queue")}
                                                                    >
                                                                        Remorque
                                                                        {sortConfig.key === "queue" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.immatriculation && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("immatriculation")}
                                                                    >
                                                                        Immatriculation
                                                                        {sortConfig.key === "immatriculation" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.proprietaire_tete && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("proprietaire_tete")}
                                                                    >
                                                                        Propriétaire tracteur
                                                                        {sortConfig.key === "proprietaire_tete" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.proprietaire_queue && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("proprietaire_queue")}
                                                                    >
                                                                        Propriétaire remorque
                                                                        {sortConfig.key === "proprietaire_queue" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.proprietaire_non_articule && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("proprietaire_non_articule")}
                                                                    >
                                                                        Propriétaire non articulé
                                                                        {sortConfig.key === "proprietaire_non_articule" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nationalite_vehicule && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nationalite_vehicule")}
                                                                    >
                                                                        Nationalité du véhicule
                                                                        {sortConfig.key === "nationalite_vehicule" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nationalite_carte_transport_tete && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nationalite_carte_transport_tete")}
                                                                    >
                                                                        Nationalités carte transport tracteur
                                                                        {sortConfig.key === "nationalite_carte_transport_tete" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nationalite_carte_transport_queue && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nationalite_carte_transport_queue")}
                                                                    >
                                                                        Nationalités carte transport remorque
                                                                        {sortConfig.key === "nationalite_carte_transport_queue" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nationalite_carte_transport_immatriculation && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nationalite_carte_transport_immatriculation")}
                                                                    >
                                                                        Nationalités carte transport non articulé
                                                                        {sortConfig.key === "nationalite_carte_transport_immatriculation" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.numero_proprietaire_tete && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("numero_proprietaire_tete")}
                                                                    >
                                                                        Tél. propriétaire tracteur
                                                                        {sortConfig.key === "numero_proprietaire_tete" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.numero_proprietaire_queue && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("numero_proprietaire_queue")}
                                                                    >
                                                                        Tél. propriétaire remorque
                                                                        {sortConfig.key === "numero_proprietaire_queue" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.numero_proprietaire_non_articule && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("numero_proprietaire_non_articule")}
                                                                    >
                                                                        Tél. propriétaire non articulé
                                                                        {sortConfig.key === "numero_proprietaire_non_articule" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.charge_utile && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("charge_utile")}
                                                                    >
                                                                        Charge utile totale
                                                                        {sortConfig.key === "charge_utile" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.charge_utile1 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("charge_utile1")}
                                                                    >
                                                                        Charge utile 1
                                                                        {sortConfig.key === "charge_utile1" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.charge_utile2 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("charge_utile2")}
                                                                    >
                                                                        Charge utile 2
                                                                        {sortConfig.key === "charge_utile2" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nombre_essieux1 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nombre_essieux1")}
                                                                    >
                                                                        Essieux 1
                                                                        {sortConfig.key === "nombre_essieux1" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.nombre_essieux2 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("nombre_essieux2")}
                                                                    >
                                                                        Essieux 2
                                                                        {sortConfig.key === "nombre_essieux2" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.tuslock2 && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("tuslock2")}
                                                                    >
                                                                        N. de twist lock
                                                                        {sortConfig.key === "tuslock2" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.conducteur_principal && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("conducteur_principal")}
                                                                    >
                                                                        Conducteur principal
                                                                        {sortConfig.key === "conducteur_principal" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.numero_permis_principal && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("numero_permis_principal")}
                                                                    >
                                                                        Permis principal
                                                                        {sortConfig.key === "numero_permis_principal" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.categorie_permis_principal && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("categorie_permis_principal")}
                                                                    >
                                                                        Catégorie permis principal
                                                                        {sortConfig.key === "categorie_permis_principal" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.tel_conducteur_principal && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("tel_conducteur_principal")}
                                                                    >
                                                                        Tél. conducteur principal
                                                                        {sortConfig.key === "tel_conducteur_principal" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.conducteur_assistant && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                        onClick={() => handleSort("conducteur_assistant")}
                                                                    >
                                                                        Conducteur assistant
                                                                        {sortConfig.key === "conducteur_assistant" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.numero_permis_assistant && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("numero_permis_assistant")}
                                                                    >
                                                                        Permis assistant
                                                                        {sortConfig.key === "numero_permis_assistant" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.categorie_permis_assistant && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("categorie_permis_assistant")}
                                                                    >
                                                                        Catégorie permis assistant
                                                                        {sortConfig.key === "categorie_permis_assistant" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.tel_conducteur_assistant && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("tel_conducteur_assistant")}
                                                                    >
                                                                        Tél. conducteur assistant
                                                                        {sortConfig.key === "tel_conducteur_assistant" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.type_camion && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("type_camion")}
                                                                    >
                                                                        Type camion
                                                                        {sortConfig.key === "type_camion" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.statut && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("statut")}
                                                                    >
                                                                        Statut
                                                                        {sortConfig.key === "statut" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.ref_categorie && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("ref_categorie")}
                                                                    >
                                                                        Référence catégorie
                                                                        {sortConfig.key === "ref_categorie" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.destination && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("destination")}
                                                                    >
                                                                        Destination
                                                                        {sortConfig.key === "destination" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.parc && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("parc")}
                                                                    >
                                                                        Parc
                                                                        {sortConfig.key === "parc" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.type_parc && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("type_parc")}
                                                                    >
                                                                        Type de parc
                                                                        {sortConfig.key === "type_parc" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.utilisateur && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("utilisateur")}
                                                                    >
                                                                        Ajouté par
                                                                        {sortConfig.key === "utilisateur" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                {visibleColumns.date_arrivee_parc_tampon && (
                                                                    <th
                                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                        onClick={() => handleSort("date_arrivee_parc_tampon")}
                                                                    >
                                                                        Arrivée parc tampon
                                                                        {sortConfig.key === "date_arrivee_parc_tampon" &&
                                                                            (sortConfig.direction === "descending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                    </th>
                                                                )}

                                                                <th className="text-center">Actions</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {isLoading ? (
                                                                <tr>
                                                                    <td colSpan="100%" className="text-center">
                                                                        <Spinner animation="border" size="sm" /> Chargement des données...
                                                                    </td>
                                                                </tr>
                                                            ) : filteredCamions.length > 0 ? (
                                                                filteredCamions.map((n) => (
                                                                    <tr key={n.id}>
                                                                        {visibleColumns.date_sortie_reele && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {formatDate(n.date_sortie_reele)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.ordre && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                N°{n.ordre}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.atellage && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.atellage === '1' ? 'Articulé' : 'Non articulé'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.camion && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.atellage === '1'
                                                                                    ? `${n.tete || 'N/A'} + ${n.queue || 'N/A'}`
                                                                                    : n.immatriculation || 'N/A'
                                                                                }
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.reference_carte_transport_1 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.reference_carte_transport_1 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.reference_carte_transport_2 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.reference_carte_transport_2 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.tete && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.tete || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.queue && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.queue || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.immatriculation && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.immatriculation || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.proprietaire_tete && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.proprietaire_tete || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.proprietaire_queue && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.proprietaire_queue || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.proprietaire_non_articule && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.proprietaire_non_articule || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nationalite_vehicule && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.atellage === "1"
                                                                                    ? n.code_nationalite_tete || 'Non défini'
                                                                                    : n.code_nationalite_non_articule || 'Non défini'
                                                                                }
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nationalite_carte_transport_tete && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.nationalite_carte_transport_tete && n.nationalite_carte_transport_tete.length > 0
                                                                                    ? n.nationalite_carte_transport_tete.map(nat => nat.name || nat.code).join(', ')
                                                                                    : 'Aucune'
                                                                                }
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nationalite_carte_transport_queue && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.nationalite_carte_transport_queue && n.nationalite_carte_transport_queue.length > 0
                                                                                    ? n.nationalite_carte_transport_queue.map(nat => nat.name || nat.code).join(', ')
                                                                                    : 'Aucune'
                                                                                }
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nationalite_carte_transport_immatriculation && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.nationalite_carte_transport_immatriculation && n.nationalite_carte_transport_immatriculation.length > 0
                                                                                    ? n.nationalite_carte_transport_immatriculation.map(nat => nat.name || nat.code).join(', ')
                                                                                    : 'Aucune'
                                                                                }
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.numero_proprietaire_tete && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.numero_proprietaire_tete || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.numero_proprietaire_queue && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.numero_proprietaire_queue || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.numero_proprietaire_non_articule && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.numero_proprietaire_non_articule || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.charge_utile && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.charge_utile || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.charge_utile1 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.charge_utile1 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.charge_utile2 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.charge_utile2 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nombre_essieux1 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.nombre_essieux1 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nombre_essieux2 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.nombre_essieux2 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.tuslock2 && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.tuslock2 || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.conducteur_principal && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.conducteur_principal || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.numero_permis_principal && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.numero_permis_principal || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.categorie_permis_principal && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.categorie_permis_principal || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.tel_conducteur_principal && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.tel_conducteur_principal || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.conducteur_assistant && (
                                                                            <td className="d-none d-md-table-cell text-justify">
                                                                                {n.conducteur_assistant || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.numero_permis_assistant && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.numero_permis_assistant || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.categorie_permis_assistant && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.categorie_permis_assistant || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.tel_conducteur_assistant && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.tel_conducteur_assistant || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.type_camion && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.type_camion || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.statut && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.statut === "arrive_parc_tampon" && (
                                                                                    <span className="badge badge-primary text-black">Camion entré</span>
                                                                                )}
                                                                                {n.statut === "en_retard" && (
                                                                                    <span className="badge badge-danger">Camion en retard</span>
                                                                                )}
                                                                                {n.statut === "Sorti" && (
                                                                                    <span className="badge badge-success">Camion en route</span>
                                                                                )}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.ref_categorie && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.ref_categorie || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.destination && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.destination || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.parc && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.parc || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.type_parc && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.type_parc || 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.utilisateur && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.utilisateur ? `${n.utilisateur.nom} ${n.utilisateur.prenoms}` : 'N/A'}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.date_arrivee_parc_tampon && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {n.date_arrivee_parc_tampon ? `${formatDate(n.date_arrivee_parc_tampon)}` : ''}
                                                                            </td>
                                                                        )}

                                                                        <td
                                                                            className="text-center"
                                                                            style={{ position: "relative" }}
                                                                        >
                                                                            <div>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setOpenDropdownId(
                                                                                            openDropdownId === n.id
                                                                                                ? null
                                                                                                : n.id
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        background: "none",
                                                                                        border: "none",
                                                                                        padding: "0 5px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                >
                                                                                    <FaEllipsisV title="Actions" />
                                                                                </button>

                                                                                {openDropdownId === n.id && (
                                                                                    <div
                                                                                        style={{
                                                                                            position: "fixed",
                                                                                            zIndex: 1000,
                                                                                            minWidth: "60px",
                                                                                            right: "50px",
                                                                                            backgroundColor: "white",
                                                                                            border: "1px solid #ddd",
                                                                                            borderRadius: "4px",
                                                                                            boxShadow:
                                                                                                "0 2px 10px rgba(0,0,0,0.2)",
                                                                                            maxHeight: "150px",
                                                                                            overflowY: "auto",
                                                                                            scrollbarWidth: "thin",
                                                                                            scrollbarColor: "#ddd #f8f9fa",
                                                                                        }}
                                                                                        className="custom-scrollbar"
                                                                                    >
                                                                                        <div
                                                                                            style={getButtonStyle(n.statut)}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleParcTamponClick(n);

                                                                                            }}
                                                                                        >
                                                                                            <FaOutdent
                                                                                                className="mr-2"
                                                                                                style={{

                                                                                                    color: STATUT_ACTIONS[n.statut]?.disabled ? "gray" : "blue",
                                                                                                }}
                                                                                                size={14}
                                                                                            />
                                                                                            <span>Arrivé Parc Tampon</span>
                                                                                        </div>

                                                                                        <div style={{ borderTop: "1px solid #eee" }} />

                                                                                        <div
                                                                                            style={{
                                                                                                padding: "8px 16px",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                ":hover": {
                                                                                                    backgroundColor: "#f8f9fa",
                                                                                                },
                                                                                            }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                setSelectedCamion(n);
                                                                                                setShowModalHistorique(true);
                                                                                                setOpenDropdownId(null);
                                                                                            }}
                                                                                        >
                                                                                            <FaHistory
                                                                                                className="mr-2"
                                                                                                style={{ color: "green" }}
                                                                                                size={14}
                                                                                            />
                                                                                            <span>Historique</span>
                                                                                        </div>

                                                                                        <div style={{ borderTop: "1px solid #eee" }} />

                                                                                        <div
                                                                                            style={{
                                                                                                padding: "8px 16px",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                ":hover": {
                                                                                                    backgroundColor: "#f8f9fa",
                                                                                                },
                                                                                            }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleShowRemplacerModal(n);
                                                                                                setShowRemplacerCamionModal(true);
                                                                                                setOpenDropdownId(null);
                                                                                            }}
                                                                                        >
                                                                                            <FaSignOutAlt
                                                                                                className="mr-2"
                                                                                                style={{ color: "blue" }}
                                                                                                size={14}
                                                                                            />
                                                                                            <span>Amendement</span>
                                                                                        </div>

                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="100%" className="text-center text-muted">
                                                                        Aucun camion à afficher
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(
                                                            currentPage * itemsPerPage,
                                                            totalItems
                                                        )} sur ${totalItems}`
                                                    }
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={() => {
                                                            if (currentPage > 1) {
                                                                fetchCamionsParcTampon(currentPage - 1);
                                                            }
                                                        }}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                        const pageNum = i + 1;
                                                        return (
                                                            <button
                                                                key={pageNum}
                                                                onClick={() => fetchCamionsParcTampon(pageNum)}
                                                                className={`btn ${currentPage === pageNum ? "btn-default" : "btn-light"} mx-1`}
                                                            >
                                                                {pageNum}
                                                            </button>
                                                        );
                                                    })}

                                                    {totalPages > 5 && (
                                                        <>
                                                            <span className="mx-1">...</span>
                                                            <button
                                                                onClick={() => fetchCamionsParcTampon(totalPages)}
                                                                className="btn btn-light mx-1"
                                                            >
                                                                {totalPages}
                                                            </button>
                                                        </>
                                                    )}

                                                    <button
                                                        onClick={() => {
                                                            if (currentPage < totalPages) {
                                                                fetchCamionsParcTampon(currentPage + 1);
                                                            }
                                                        }}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer text-center">
                    <div>
                        <strong>
                            <a
                                href="https://www.adnservicespro.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ADN Services
                            </a>
                        </strong>{" "}
                        &copy; 2025. Tous droits réservés | Réalisé par{" "}
                        <a
                            href="https://inovact.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            INOVACT SARL
                        </a>
                    </div>
                </div>

                {/* Modal de confirmation de date d'arrivée sur le parc tampon */}
                <Modal
                    show={showParcTamponModal}
                    onHide={() => {
                        setShowParcTamponModal(false);
                        setSelectedCamion(null);
                    }}
                >
                    <Modal.Header>
                        <Modal.Title>Enregistrement arrivée parc tampon</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        Confirmer l'entrée du camion {getImmatriculation()} au parc tampon

                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShowParcTamponModal(false);
                                setSelectedCamion(null);
                            }}
                        >
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleArriveeParcTampon}
                            disabled={!selectedCamion}
                        >
                            Confirmer l'enregistrement
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal d'affichage ^pour les camions qui viennent en retard */}
                <Modal
                    show={showErreurModal}
                    onHide={() => setShowErreurModal(false)}
                >
                    <Modal.Header>
                        <Modal.Title>Action impossible</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <strong>
                            🚫 Impossible de faire entrer le camion {getImmatriculation()} dans le parc tampon car il est en retard selon le temps prévu.
                        </strong>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowErreurModal(false)}
                        >
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal pour afficher l'historique du parcours d'un camion */}
                <ModalHistorique
                    show={showModalHistorique}
                    camion={selectedCamion}
                    onHide={() => {
                        setShowModalHistorique(false);
                        setSelectedCamion(null)
                    }}
                />

                {/* Modal pour amender un camion qui n'est pas sorti du parc après émission de lettre de voiture   */}
                <Modal show={showRemplacerCamionModal} >
                    <Modal.Header>
                        <Modal.Title>Amendement de camion</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="alert alert-warning">
                            <strong>Attention : opération sensible</strong>
                        </div>

                        <p>
                            Cette action permet de remplacer un camion ayant quitté le parc avec une lettre de voiture,
                            mais dont l'arrivée sur le parc tampon n'a pas été enregistrée dans le délai réglementaire autorisé.
                        </p>

                        <p>
                            Après confirmation, le système sélectionnera automatiquement un camion de
                            remplacement disponible dans la liste FIFO et répondant aux mêmes critères
                            d'éligibilité, afin d'assurer la continuité du processus d'attribution du fret.
                        </p>

                        <div className="alert alert-danger">
                            <strong>Important :</strong> Cette opération est <strong>irréversible</strong>.
                            <br />
                            Une fois l'amendement effectué, le camion initial ne pourra plus être réaffecté
                            dans le processus en cours, il perdra donc son tour.
                        </div>

                        <p className="mb-0">
                            <strong>Confirmez-vous vouloir procéder à cet amendement&nbsp;?</strong>
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseRemplacerModal}>
                            Annuler
                        </Button>

                        <Button
                            variant="danger"
                            onClick={handleRemplacerCamionSortir}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                "Confirmer l'amendement"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>


            </div>
            <GlossaireSidebar
                isOpen={showGlossary}
                onClose={() => setShowGlossary(false)}
            />
        </div>
    );
};

export default ListeParcTampon;